import Vue from 'vue'
import Vuex from 'vuex'
import appHelper from "../helpers/app_helper";
import app from "../main";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    languageCode: null,
    userInfo: null,
    mainButtons: null
  },
  getters: {
    userInfo: (state) => state.userInfo,
    mainButtons: (state) => state.mainButtons,
    languageCode: (state) => {
      // Get from state
      if (state.languageCode)
        return state.languageCode;

      let languageCode = appHelper.getSetting("languageCode");
      if (languageCode)
        return languageCode;

      // Get from queryString
      languageCode = new URLSearchParams(window.location.search).get("languageCode") || "vi-VN";
      if (languageCode === "")
        languageCode = "vi-VN";

      if (languageCode.length > 2)
        languageCode = languageCode.substr(0, 2);

      appHelper.setSetting("languageCode", languageCode);
      return languageCode;
    }
  },
  mutations: {
    SET_LANGUAGE_CODE: (state, payload) => {
      app.$i18n.locale = payload;
      state.languageCode = payload;
      appHelper.setSetting("languageCode", payload);
    },
    SET_USER_INFO: (state, payload) => state.userInfo = payload,
    SET_MAIN_BUTTONS: (state, payload) => state.mainButtons = payload
  },
  actions: {
    setLanguageCode: ({commit}, payload) => commit('SET_LANGUAGE_CODE', payload),
    setUserInfo: ({commit}, payload) => commit('SET_USER_INFO', payload),
    setMainButtons: ({commit}, payload) => commit('SET_MAIN_BUTTONS', payload)
  },
  modules: {
  }
})
